/** QR Model 2 practical limit; Google save URLs are JWTs and exceed it. */
export const MAX_QR_STRING_LENGTH = 1800;

/**
 * Backend origin for routes mounted outside `/api/v1` (e.g. `/wallet/google/add/:id`).
 */
export function getBackendOriginForWalletRoutes() {
    const base =
        process.env.REACT_APP_API_URL ||
        'http://localhost:5001/api/v1';
    try {
        const u = new URL(base, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
        let path = u.pathname.replace(/\/+$/, '') || '';
        if (path.endsWith('/api/v1')) {
            path = path.slice(0, -'/api/v1'.length);
        }
        const rootPath = path && path !== '/' ? path : '';
        return `${u.origin}${rootPath}`.replace(/\/+$/, '');
    } catch {
        return '';
    }
}

export function buildGoogleWalletAddShortcutUrl(walletPassId) {
    if (!walletPassId) {
        return null;
    }
    const origin = getBackendOriginForWalletRoutes();
    if (!origin) {
        return null;
    }
    return `${origin}/wallet/google/add/${encodeURIComponent(walletPassId)}`;
}

/**
 * Resolve what to encode in a customer pass QR.
 * @returns {{ qrPayload: string | null, openWalletHref: string | null, mode: 'data-url' | 'svg' | 'too-long' }}
 */
export function resolveCustomerWalletQrPayload(_customer, originalWalletLink, fallbackRewardsUrl) {
    const link = originalWalletLink || null;
    const fallback = typeof fallbackRewardsUrl === 'string' ? fallbackRewardsUrl : null;

    if (link && String(link).startsWith('data:')) {
        return { qrPayload: link, openWalletHref: link, mode: 'data-url' };
    }

    const primary = link || fallback;
    if (typeof primary !== 'string') {
        return { qrPayload: null, openWalletHref: link, mode: 'too-long' };
    }
    if (primary.length > MAX_QR_STRING_LENGTH) {
        return { qrPayload: null, openWalletHref: link || primary, mode: 'too-long' };
    }

    return { qrPayload: primary, openWalletHref: link || primary, mode: 'svg' };
}
